import axios from './index';

export const getWalletRequest = (values) =>
  axios.get(
    `/v1/admins/get/wallets/-/${values?.vendorID || '-'}/${values?.type || '-'}/${
      values?.page || '1'
    }/${values?.limit || '-'}`
  );
